<template>
    <div
        class="mobile-menu"
        v-if="!!actionRight.text || !!actionLeft.text || !!actionMiddle.text"
    >
        <a
            class="mobile-menu-option"
            :href="actionLeft.nav || '#'"
             v-if="!!actionLeft"
        >
            <slot name="iconLeft" />
                {{ actionLeft.text }}
        </a>
        <a
            class="mobile-menu-option"
            :href="actionMiddle.nav || '#'"
            v-if="!!actionMiddle"
        >
            <slot name="iconMiddle" />
            {{ actionMiddle.text }}
         </a>
        <a
            class="mobile-menu-option"
            :href="actionRight.nav || '#'"
            v-if="!!actionRight"
        >
            <slot name="iconRight" />
            {{ actionRight.text }}
         </a>
    </div>
</template>
<script>

export default {
    props: {
        actionLeft: {
            type: Object,
            required: true,
        },
        actionMiddle: {
            type: Object,
            required: true,
        },
         actionRight: {
            type: Object,
            required: true,
        }
    },
}
</script>
